import React, { useState, useContext, useEffect, useCallback } from "react";
import axios from "axios";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from 'react-router-dom';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomCard from "components/Home/CustomCard";
import CustomCardAlerts from "components/Home/CustomCardAlerts";
import CustomCardActions from "components/Home/CustomCardActions";
import CustomCardEntiteInfo from "components/Home/CustomCardEntiteInfo";
import CustomCardMBM from "components/Home/CustomCardMBM";
import CustomCardWeather from "components/Home/CustomCardWeather";
import CustomCardDataGrid from "components/Home/CustomCardDataGrid";
import CustomCardEvolution from "components/Home/CustomCardEvolution";
import { DateDropDownListItemStyle, LoadingDivFull } from "../../assets/jss/material-dashboard-pro-react/components/Analyses/CustomSelectHeader";
import LoadingApp from "../../components/Modal/LoadingApp";
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import uuid from "react-uuid";
import API from "api/api";
import UserService from "services/UserService";
import DateContext from "context/DateContext";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import Paper from "@mui/material/Paper";
import ChartV2, { getChartCategoryScriptV2 } from "components/ChartV2/ChartV2";
import { getHome, getChartV2, getChart, getWeather } from "../../services/ConfigServices";
import { getChartCategoryScript } from "components/Charts/getChartCategoryScript";
import ReactLoading from "react-loading";
import moment from "moment";
import styled from "styled-components";
import postPageVisit from "services/LogService";
import { getMarkets } from "services/ConfigServices";
import CustomCardMarkets from "components/Home/CustomCardMarkets";


export default function Home() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const options = JSON.parse(localStorage.getItem('memoptions')) || [];
  const currentusertype = localStorage.getItem('userType');

  const marketvisibility = currentusertype === '1' || (options.find((x) => x.id === 'markets') && permis.includes("markets_access"))

  let year = new Date();
  year = new Date(year.setMonth(year.getMonth() - 1));
  year = year.getFullYear();
  let yearbefore = year - 1;

  const [data, setData] = useState({});
  const [charts, setCharts] = useState({});
  const [chartsarr, setChartsarr] = useState([]);
  const [weatherData, setWeatherData] = useState({});
  const [markets, setMarkets] = useState([]);

  const appContext = useContext(AdvancedSearchContext);
  const {
    chartIdGroup,
    setChartIdGroup,
    setSelectedNodesInfo,
    setOutofcontextclic,
    setPage,
    page,
  } = appContext;

  const [redirState, setRedirState] = useState(false);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/home",
      }}
    />
  );


  useEffect(() => {
    setPage('home');
    postPageVisit('home');
  }, []);

  const fetchMyAPI = useCallback(async () => {
    //console.log("getHome ",chartIdGroup);
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      setData({});
      let series =
        process.env.REACT_APP_HOME_SERIE_ELEC_1Y +
        "," +
        process.env.REACT_APP_HOME_SERIE_GAS_1Y +
        "," +
        process.env.REACT_APP_HOME_SERIE_WATER_1Y +
        "," +
        process.env.REACT_APP_HOME_SERIE_OTHER_1Y +
        "," +
        process.env.REACT_APP_HOME_SERIE_ELEC_0Y +
        "," +
        process.env.REACT_APP_HOME_SERIE_GAS_0Y +
        "," +
        process.env.REACT_APP_HOME_SERIE_WATER_0Y +
        "," +
        process.env.REACT_APP_HOME_SERIE_OTHER_0Y +
        "," +
        process.env.REACT_APP_HOME_SERIE_ELEC_EVOL +
        "," +
        process.env.REACT_APP_HOME_SERIE_GAS_EVOL +
        "," +
        process.env.REACT_APP_HOME_SERIE_WATER_EVOL +
        "," +
        process.env.REACT_APP_HOME_SERIE_OTHER_EVOL +
        "," +
        process.env.REACT_APP_HOME_SERIE_CARBON_1Y;

      let response = await API.get(
        getHome(
          `${chartIdGroup}`,
          series,
          process.env.REACT_APP_HOME_SERIE_ELEC_0Y
        ),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      );
      // console.log(response.data);
      // setChartIdGroup("2151"); test
      setChartsarr([]);
      setCharts({});
      setData(response.data);
    }
  }, [chartIdGroup]);

  useEffect(() => {
    if (data.display) {
      let entityParameters = data.entityparameters;
      Object.keys(data.display).map((column) => {
        Object.keys(data.display[column].cards).forEach((cardkey) => {
          let cardobj = data.display[column].cards[cardkey];
          if (cardobj.type === 'chart') {
            getChartDisplay(cardobj, cardkey, entityParameters);
          }
          else if (cardobj.type === 'weather') {
            getWeatherData();
          }
          else if (cardobj.type === 'markets' && marketvisibility) {
            getMarketsData();
          }
        });
      });
    }
  }, [data]);

  // useEffect(() => {
  //   if (data.display) {
  //     let entityParameters = data.entityparameters;
  //     Object.keys(data.display).map((column) => {
  //       Object.keys(data.display[column].cards).forEach((cardkey) => {
  //         let cardobj = data.display[column].cards[cardkey];
  //         if (cardobj.type === 'chart') {
  //           console.log(column, cardkey, charts[cardkey]);

  //         }
  //       });
  //     });
  //   }
  // }, [charts]);

  useEffect(() => {
    // console.log('effect ', chartIdGroup);
    fetchMyAPI();
  }, [chartIdGroup]);

  const date = useContext(DateContext);

  const colorRef = "rgba(215,206,239,1)";
  const colorElec1 = "rgba(145,199,60,0.6)";
  const colorElec2 = "rgba(145,199,60,1)";
  const colorGaz1 = "rgba(255,118,58,0.6)";
  const colorGaz2 = "rgba(255,118,58,1)";
  const colorWater1 = "rgba(62,143,198,0.6)";
  const colorWater2 = "rgba(62,143,198,1)";
  const colorAutre1 = "rgba(197,63,63,0.6)";
  const colorAutre2 = "rgba(197,63,63,1)";
  //  console.log(date);

  const LoadingDiv = styled.div`
    height: 100vh;
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    padding-top: 35vh;
  `;

  const optionsElectricite = {
    chart: {
      type: "column",
      height: "350px",
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: [""],
    },
    yAxis: [
      {
        min: 0,
        title: {
          text: "MWh",
        },
      },
    ],
    legend: {
      shadow: false,
      //enabled: false
    },
    tooltip: {
      shared: true,
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: "Référence",
        color: colorRef,

        data: data.locationinfo?.refelec ? [data.locationinfo?.refelec] : [],
        tooltip: {
          valueSuffix: " MWh",
        },
        pointPadding: 0.3,
        pointPlacement: -0.2,
      },
      {
        name: "" + yearbefore,
        color: colorElec1,
        data: data.locationinfo?.[process.env.REACT_APP_HOME_SERIE_ELEC_1Y]
          ? [data.locationinfo[process.env.REACT_APP_HOME_SERIE_ELEC_1Y]]
          : [],
        tooltip: {
          valueSuffix: " MWh",
        },
        pointPadding: 0.3,
        pointPlacement: 0.2,
      },
      {
        name: "" + year,
        color: colorElec2,
        data: data.locationinfo?.[process.env.REACT_APP_HOME_SERIE_ELEC_0Y]
          ? [data.locationinfo[process.env.REACT_APP_HOME_SERIE_ELEC_0Y]]
          : [],
        tooltip: {
          valueSuffix: " MWh",
        },
        pointPadding: 0.4,
        pointPlacement: 0.2,
      },
    ],
  };

  const optionsGaz = {
    chart: {
      type: "column",
      height: "350px",
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: [""],
    },
    yAxis: [
      {
        min: 0,
        title: {
          text: "MWh",
        },
      },
    ],
    legend: {
      shadow: false,
      //enabled: false
    },
    tooltip: {
      shared: true,
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: "Référence",
        color: colorRef,

        data: data.locationinfo?.refgas ? [data.locationinfo?.refgas] : [],
        tooltip: {
          valueSuffix: " MWh",
        },
        pointPadding: 0.3,
        pointPlacement: -0.2,
      },
      {
        name: "" + yearbefore,
        color: colorGaz1,
        data: data.locationinfo?.[process.env.REACT_APP_HOME_SERIE_GAS_1Y]
          ? [data.locationinfo[process.env.REACT_APP_HOME_SERIE_GAS_1Y]]
          : [],
        tooltip: {
          valueSuffix: " MWh",
        },
        pointPadding: 0.3,
        pointPlacement: 0.2,
      },
      {
        name: "" + year,
        color: colorGaz2,
        data: data.locationinfo?.[process.env.REACT_APP_HOME_SERIE_GAS_0Y]
          ? [data.locationinfo[process.env.REACT_APP_HOME_SERIE_GAS_0Y]]
          : [],
        tooltip: {
          valueSuffix: " MWh",
        },
        pointPadding: 0.4,
        pointPlacement: 0.2,
      },
    ],
  };

  const optionsEau = {
    chart: {
      type: "column",
      height: "350px",
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: [""],
    },
    yAxis: [
      {
        min: 0,
        title: {
          text: "m3",
        },
      },
    ],
    legend: {
      shadow: false,
      //enabled: false
    },
    tooltip: {
      shared: true,
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: "Référence",
        color: colorRef,

        data: data.locationinfo?.refwater ? [data.locationinfo?.refwater] : [],
        tooltip: {
          valueSuffix: " m3",
        },
        pointPadding: 0.3,
        pointPlacement: -0.2,
      },
      {
        name: "" + yearbefore,
        color: colorWater1,
        data: data.locationinfo?.[process.env.REACT_APP_HOME_SERIE_WATER_1Y]
          ? [data.locationinfo[process.env.REACT_APP_HOME_SERIE_WATER_1Y]]
          : [],
        tooltip: {
          valueSuffix: " m3",
        },
        pointPadding: 0.3,
        pointPlacement: 0.2,
      },
      {
        name: "" + year,
        color: colorWater2,
        data: data.locationinfo?.[process.env.REACT_APP_HOME_SERIE_WATER_0Y]
          ? [data.locationinfo[process.env.REACT_APP_HOME_SERIE_WATER_0Y]]
          : [],
        tooltip: {
          valueSuffix: " m3",
        },
        pointPadding: 0.4,
        pointPlacement: 0.2,
      },
    ],
  };

  const optionsAutres = {
    chart: {
      type: "column",
      height: "350px",
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: [""],
    },
    yAxis: [
      {
        min: 0,
        title: {
          text: "MWh",
        },
      },
    ],
    legend: {
      shadow: false,
      //enabled: false
    },
    tooltip: {
      shared: true,
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: "Référence",
        color: colorRef,

        data: data.locationinfo?.refother ? [data.locationinfo?.refother] : [],
        tooltip: {
          valueSuffix: " MWh",
        },
        pointPadding: 0.3,
        pointPlacement: -0.2,
      },
      {
        name: "" + yearbefore,
        color: colorAutre1,
        data: data.locationinfo?.[process.env.REACT_APP_HOME_SERIE_OTHER_1Y]
          ? [data.locationinfo[process.env.REACT_APP_HOME_SERIE_OTHER_1Y]]
          : [],
        tooltip: {
          valueSuffix: " MWh",
        },
        pointPadding: 0.3,
        pointPlacement: 0.2,
      },
      {
        name: "" + year,
        color: colorAutre2,
        data: data.locationinfo?.[process.env.REACT_APP_HOME_SERIE_OTHER_0Y]
          ? [data.locationinfo[process.env.REACT_APP_HOME_SERIE_OTHER_0Y]]
          : [],
        tooltip: {
          valueSuffix: " MWh",
        },
        pointPadding: 0.4,
        pointPlacement: 0.2,
      },
    ],
  };

  const columns = [
    {
      headerName: "Nom",
      field: "name",
      flex: 0.6,
    },
    {
      headerName: "Consommation",
      field: "value",
      type: "number",
      flex: 0.4,
      renderCell: (params) => (new Intl.NumberFormat('fr-FR').format(params.value)
      ),
    },
  ];
  const rows = [];

  const printSpecificCard = (cardkey, cardobj) => {
    let cardresult = data[cardkey];
    if (cardobj.type === 'chart' && !charts[cardkey])
      return <></>;
    if (cardobj.type === 'markets' && !marketvisibility)
      return <></>;
    else {
      let obj =
        <GridItem xs={12} sm={12} md={cardobj.size} lg={cardobj.size}>
          {
            cardobj.type === 'mainmbm' ?
              <CustomCardMBM siteinfo={cardresult.siteinfo} />
              :
              cardobj.type === 'chart' ? charts[cardkey]
                :
                cardobj.type === 'weather' ?
                  <CustomCardWeather weatherData={weatherData} />
                  :
                  cardobj.type === 'markets' ?
                    <CustomCardMarkets markets={markets} />
                    :
                    cardobj.type === 'entityinfo' ?
                      <CustomCardEntiteInfo
                        locationInfo={cardresult.locationinfo}
                        siteCount={cardresult.sitecount}
                      />
                      :
                      <></>
          }

        </GridItem>
      return obj;
    }
  }

  const getWeatherData = () => {
    let url = getWeather(chartIdGroup);
    axios.get(
      url,
      {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
    )
      .then((response) => {
        setWeatherData(response.data);
      })
      .catch((error) => {
        console.error(error);
      })
  }

  const getMarketsData = () => {
    let url = getMarkets(chartIdGroup);
    axios.get(
      url,
      {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
    )
      .then((response) => {
        let marketstmp = response.data.markets.filter((market)=>market.parameters?.status === 'inprogress');
        setMarkets(marketstmp);
      })
      .catch((error) => {
        console.error(error);
      })
  }

  const getChartDisplay = (chart, card, entityParameters) => {
    const requestid = uuid();
    let chartsource = 'existing';
    let url = '';
    if (chart.version && chart.version === 'v2') {
      url = getChartV2(chartIdGroup, chart.chart, chart.datebegin, chart.dateend, false, chartsource, '', requestid);
    }
    else {
      url = getChart(chartIdGroup, chart.chart, chart.datebegin, chart.dateend, false, chartsource, '', '', '', '', '', '', '', requestid);
    }
    let datetitle = moment(chart.datebegin).format('DD/MM/yyyy') + " au " + moment(chart.dateend).format('DD/MM/yyyy');
    axios.get(
      url,
      {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
    )
      .then((response) => {
        let resultchart = {};
        resultchart.serverData = response.data.chart;
        if (resultchart?.serverData?.title)
          resultchart.serverData.title = resultchart.serverData.title + " (" + datetitle + ")";
        if (resultchart?.serverData?.name)
          resultchart.serverData.name = resultchart.serverData.name + " (" + datetitle + ")";
        if (resultchart.serverData.version === 'v1') {
          resultchart = getChartCategoryScript(
            resultchart.serverData?.data,
            resultchart.serverData?.title,
            resultchart.serverData?.category,
            resultchart.serverData?.type,
            resultchart.serverData?.stacking,
            resultchart.chart,
            true
          )[0];
          ;
        }
        else {
          if (response.data.chart.series.length > 0)
            resultchart = getChartCategoryScriptV2(resultchart.serverData, chart.chart, entityParameters, true);
          else
            resultchart = '';
        }
        chartsarr.push(resultchart);
        charts[card] = resultchart;
        setCharts({ ...charts });
      })
      .catch((error) => {
        console.error(error);
      })
  }

  const onRowClick = (rowParams, event) => {
    let idgroup = "" + rowParams.row.id;
    setOutofcontextclic(idgroup);
    setChartIdGroup(idgroup);
    setSelectedNodesInfo(rowParams.row.name);
  };

  return (
    <ErrorBoundary
      onReset={() => setRedirState(true)}
      FallbackComponent={ErrorFallbackDialog}
      page={"home"}
    >
      {chartIdGroup[0] !== "0" ? (
        data.locationinfo ? (
          <div>
            {/* <Hidden xsDown smDown mdDown> */}
            {/* <Paper sx={{ display: {  sm: 'block', md: 'block', xs: 'block' } }} > */}
            <GridContainer>
              <GridItem xs={12} sm={4} md={4} lg={3}>
                <CustomCardEntiteInfo
                  locationInfo={data.locationinfo}
                  siteCount={data.sitecount}
                />
                <CustomCardEvolution
                  cardTitle={"Evolution de la consommation mensuelle"}
                  dataName1={"Electricité"}
                  data1result={
                    data.locationinfo[
                    process.env.REACT_APP_HOME_SERIE_ELEC_EVOL
                    ]
                  }
                  dataName2={"Gaz"}
                  data2result={
                    data.locationinfo[
                    process.env.REACT_APP_HOME_SERIE_GAS_EVOL
                    ]
                  }
                  dataName3={"Eau"}
                  data3result={
                    data.locationinfo[
                    process.env.REACT_APP_HOME_SERIE_WATER_EVOL
                    ]
                  }
                  dataName4={"Autres"}
                  data4result={
                    data.locationinfo[
                    process.env.REACT_APP_HOME_SERIE_OTHER_EVOL
                    ]
                  }
                />
              </GridItem>

              <GridItem xs={12} sm={12} md={12} lg={3}>
                <CustomCard
                  cardTitle={`électricité`}
                  cardSubTitle={
                    data.locationinfo[
                    process.env.REACT_APP_HOME_SERIE_ELEC_0Y
                    ] || 0
                  }
                  cardSubTitleUnit={"MWh"}
                  options={optionsElectricite}
                />
                <CustomCard
                  cardTitle={"eau"}
                  cardSubTitle={
                    data.locationinfo[
                    process.env.REACT_APP_HOME_SERIE_WATER_0Y
                    ] || 0
                  }
                  cardSubTitleUnit={"m3"}
                  options={optionsEau}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={12} lg={3}>
                <CustomCard
                  cardTitle={"gaz"}
                  cardSubTitle={
                    data.locationinfo[
                    process.env.REACT_APP_HOME_SERIE_GAS_0Y
                    ] || 0
                  }
                  cardSubTitleUnit={"MWh"}
                  options={optionsGaz}
                />
                <CustomCard
                  cardTitle={"autres fluides"}
                  cardSubTitle={
                    data.locationinfo[
                    process.env.REACT_APP_HOME_SERIE_OTHER_0Y
                    ] || 0
                  }
                  cardSubTitleUnit={"MWh"}
                  options={optionsAutres}
                />
              </GridItem>

              <GridItem xs={12} sm={4} md={4} lg={3}>
                {/* <CustomCardAlerts
                      cardTitle={"Alertes"}
                      dataName1={"Non consultée(s)"}
                      data1result={data.alerts?.unread}
                      dataName2={"Dont critique(s)"}
                      data2result={data.alerts?.unreadcritical}
                      dataName3={"En cours de traitement"}
                      data3result={data.alerts?.progress}
                      dataName4={"Dont critique(s)"}
                      data4result={data.alerts?.progresscritical}
                      page={"alertes"}
                    />
                    <CustomCardActions
                      cardTitle={"Plan d'actions"}
                      dataName1={"Action(s) à venir"}
                      data1result={data.actions?.tobegin}
                      dataName2={"Action(s) en cours"}
                      data2result={data.actions?.inprogress}
                      dataName3={"Action(s) à finaliser"}
                      data3result={data.actions?.overdue}
                      dataName4={"Economies réalisées"}
                      data4result={data.actions?.savings}
                      page={"actions"}
                    /> */}
                {data.locationinfo.type === 1 ? (
                  <></>
                ) : (
                  <CustomCardDataGrid
                    columns={columns}
                    rows={data.sitelist}
                    onRowClick={onRowClick}
                  />
                )}
              </GridItem>
            </GridContainer>
            {/* </Paper> */}
            {/* <Hidden xsDown smDown lgUp> */}
            {/* <Paper sx={{ display: {  sm: 'block', lg: 'none', xs: 'block' } }} >
              <GridContainer>
                <GridItem xs={12} sm={4} md={4} lg={4}>
                  <CustomCardEntiteInfo locationInfo={data.locationinfo} />
                </GridItem>

                <GridItem xs={12} sm={12} md={4} lg={4}>
                  <CustomCard
                    cardTitle={`électricité`}
                    cardSubTitle={
                      data.locationinfo[
                      process.env.REACT_APP_HOME_SERIE_ELEC_1Y
                      ]
                    }
                    cardSubTitleUnit={"MWh"}
                    options={optionsElectricite}
                  />
                  <CustomCard
                    cardTitle={"eau"}
                    cardSubTitle={
                      data.locationinfo[
                      process.env.REACT_APP_HOME_SERIE_WATER_1Y
                      ]
                    }
                    cardSubTitleUnit={"m3"}
                    options={optionsEau}
                  /> */}
            {/* <CustomCardActions
                      cardTitle={"Alertes"}
                      dataName1={"Non consultée(s)"}
                      data1result={data.actions?.unread}
                      dataName2={"En traitement"}
                      data2result={data.alerts?.inprogress}
                      dataName3={"Dépassement de puissance"}
                      data3result={data.alerts?.powerexcess}
                      dataName4={"Erreurs de facturation"}
                      data4result={"?"}
                      dataName5={"Fuites d'eau"}
                      data5result={"?"}
                      page={"alertes"}
                    /> */}
            {/* <CustomCardActions
                      cardTitle={"Plan d'actions"}
                      dataName1={"Prévue(s) ce mois"}
                      data1result={data.actions?.todo}
                      dataName2={"A venir"}
                      data2result={"?"}
                      dataName3={"En cours"}
                      data3result={data.actions?.inprogress}
                      dataName4={"Réalisés"}
                      data4result={"?"}
                      dataName5={"Objectifs atteints"}
                      data5result={"?"}
                      page={"actions"}
                    /> */}
            {/* </GridItem>
                <GridItem xs={12} sm={12} md={4} lg={4}>
                  <CustomCard
                    cardTitle={"gaz"}
                    cardSubTitle={
                      data.locationinfo[process.env.REACT_APP_HOME_SERIE_GAS_1Y]
                    }
                    cardSubTitleUnit={"MWh"}
                    options={optionsGaz}
                  />
                  <CustomCard
                    cardTitle={"Autres fluides"}
                    cardSubTitle={
                      data.locationinfo[
                      process.env.REACT_APP_HOME_SERIE_OTHER_1Y
                      ]
                    }
                    cardSubTitleUnit={"MWh"}
                    options={optionsAutres}
                  />
                  {data.locationinfo.type === 1 ? (
                    <></>
                  ) : (
                    <CustomCardDataGrid
                      columns={columns}
                      rows={data.sitelist}
                      onRowClick={onRowClick}
                    />
                  )}
                </GridItem>
              </GridContainer> */}
            {/* </Paper> */}
          </div>
        ) :
          data.display ?
            (
              <GridContainer>
                {
                  Object.keys(data.display).map((column) =>
                    <GridItem xs={12} sm={12} md={data.display[column].size} lg={data.display[column].size}>
                      <GridContainer>
                        {
                          Object.keys(data.display[column].cards).map((cardkey) =>
                            printSpecificCard(cardkey, data.display[column].cards[cardkey])
                          )
                        }
                      </GridContainer>
                    </GridItem>
                  )
                }
              </GridContainer>
            ) :
            (
              <div>
                <LoadingDivFull>
                  <ReactLoading
                    type={"bars"}
                    color={"#91c241"}
                    height={"20%"}
                    width={"20%"}
                  />
                </LoadingDivFull>
              </div>
            )
      ) : (
        <LoadingApp open={chartIdGroup[0] === "0" ? true : false} />
      )}
      {redirecting}
    </ErrorBoundary>
  );
}
